var _style, _g, _polygon, _polygon2, _polygon3, _polygon4, _circle, _circle2, _g2, _path, _path2, _path3, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 408.18 149.82",
    style: {
      enableBackground: "new 0 0 408.18 149.82"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.35;fill:#002051;}\n\t.st1{opacity:0.35;fill:#00C160;}\n\t.st2{fill:#0166CB;}\n\t.st3{fill:#002051;}\n\t.st4{opacity:0.35;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{clip-path:url(#SVGID_00000038406909745172330920000018344919677512559019_);fill:#FFFFFF;}\n\t.st7{clip-path:url(#SVGID_00000038406909745172330920000018344919677512559019_);}\n\t.st8{clip-path:url(#SVGID_00000075138250878626193120000011614708319461477251_);}\n\t.st9{clip-path:url(#SVGID_00000097485513382862250580000006633613192604468665_);}\n\t.st10{clip-path:url(#SVGID_00000176766175174484939880000001211035739685294994_);}\n\t.st11{clip-path:url(#SVGID_00000027595892569902979170000008859491449367607694_);}\n\t.st12{clip-path:url(#SVGID_00000080177304705063511570000015026897936341664387_);}\n\t.st13{clip-path:url(#SVGID_00000031187808126023469050000012721821829684093589_);}\n\t.st14{clip-path:url(#SVGID_00000134221387093822533470000013084348432702420415_);}\n\t.st15{clip-path:url(#SVGID_00000071551035871782465540000018243329836282944440_);}\n\t.st16{clip-path:url(#SVGID_00000171681021549739947400000002116212835816594579_);}\n\t.st17{clip-path:url(#SVGID_00000091721609987961204400000011071952882760142732_);}\n\t.st18{clip-path:url(#SVGID_00000052102997900537669680000002792236049847527570_);}\n\t.st19{clip-path:url(#SVGID_00000054961168431273285920000013827261005832300981_);}\n\t.st20{clip-path:url(#SVGID_00000081618435533095131120000008396234781616686221_);}\n\t.st21{clip-path:url(#SVGID_00000054247527057605609890000016100217130563970474_);}\n\t.st22{clip-path:url(#SVGID_00000077311055945102084280000016000201172321559471_);}\n\t.st23{clip-path:url(#SVGID_00000136408248894450583850000015378946161066266262_);}\n\t.st24{clip-path:url(#SVGID_00000150780964184913678890000018256305762690423733_);}\n\t.st25{clip-path:url(#SVGID_00000089560712752179401480000002453250354026815407_);}\n\t.st26{clip-path:url(#SVGID_00000162321805541316945140000016065144991685564070_);}\n\t.st27{clip-path:url(#SVGID_00000013165711539515063190000000060538663528325809_);}\n\t.st28{clip-path:url(#SVGID_00000141445040307044011480000000727873997383207046_);fill:#00C160;}\n\t.st29{clip-path:url(#SVGID_00000144320458962313062330000015608272536787613614_);}\n\t.st30{clip-path:url(#SVGID_00000146480638777623235800000010452457970610959526_);}\n\t.st31{clip-path:url(#SVGID_00000174584956331664335310000015118632234552621466_);}\n\t.st32{clip-path:url(#SVGID_00000168828428420075117460000016330113936918170025_);}\n\t.st33{clip-path:url(#SVGID_00000083773063689319411560000010022588890382322322_);}\n\t.st34{clip-path:url(#SVGID_00000025441058884935519910000017156318799649202075_);}\n\t.st35{clip-path:url(#SVGID_00000001655375802961824680000014201111533820063141_);}\n\t.st36{clip-path:url(#SVGID_00000096050825534236709050000015083295806931113115_);}\n\t.st37{clip-path:url(#SVGID_00000022549422180621574940000013356210172874074298_);}\n\t.st38{clip-path:url(#SVGID_00000043420660520698266540000002209347766943613848_);}\n\t.st39{fill:#FCFCFC;}\n\t.st40{fill:#00C160;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.73,84.48c-2.5,0-4.82,0-7.23,0c0-7.09,0-14.12,0-21.22c2.34,0,4.69,0,7.1,0c0.07,0.63,0.13,1.25,0.2,1.89 c5.93-3.64,10.22-3.31,13.31,0.77c1.78-1.03,3.41-2.44,5.29-2.97c4.66-1.32,10.6,1.19,10.37,7.47c-0.16,4.19-0.03,8.39-0.03,12.59 c0,0.46,0,0.93,0,1.46c-2.54,0-4.94,0-7.51,0c0-1.19,0-2.3,0-3.41c-0.01-3.03,0.01-6.06-0.03-9.09c-0.02-1.76-1.1-2.96-2.85-3.31 c-1.61-0.32-3.18,0.42-3.69,1.87c-0.24,0.67-0.26,1.43-0.27,2.16c-0.03,3.5-0.05,7.01,0.01,10.51c0.02,1.11-0.37,1.41-1.41,1.38 c-2.03-0.06-4.06-0.02-6.31-0.02c0-0.67,0-1.17,0-1.66c0-3.63,0.01-7.27-0.02-10.9c-0.01-1.88-1.31-3.23-3.18-3.38 c-1.96-0.15-3.42,0.87-3.54,2.87c-0.21,3.53-0.17,7.08-0.22,10.62C194.72,82.85,194.73,83.58,194.73,84.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.43,80.58c1.29-2.17,2.57-4.33,3.77-6.34c2.08,1.05,4.03,2.19,6.11,3.05c1.82,0.75,3.78,0.82,5.62-0.07 c2.15-1.05,2.45-3.37,0.49-4.71c-1.78-1.21-3.76-2.16-5.7-3.12c-3.36-1.67-6.24-3.73-7.12-7.7c-0.66-2.99,0.14-5.64,2.03-7.89 c3.38-4.02,7.84-4.82,12.74-3.81c2.45,0.51,4.87,1.23,7.02,2.88c-0.94,1.87-1.88,3.76-2.82,5.65c-0.32,0.64-0.68,0.53-1.24,0.23 c-2.14-1.14-4.38-2.08-6.86-1.76c-0.88,0.11-1.83,0.53-2.51,1.09c-1.11,0.92-1.11,2.41,0.08,3.22c1.65,1.13,3.43,2.09,5.26,2.91 c2.93,1.32,5.63,2.9,7.65,5.48c2.69,3.44,1.84,11.71-4.58,14.24c-3.18,1.25-6.43,1.54-9.83,1.11c-3.54-0.45-6.6-1.89-9.5-3.82 C156.82,81.07,156.67,80.84,156.43,80.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.78,52.8c-1.14,2.27-2.19,4.37-3.27,6.53c-3.75-2.11-7.55-2.58-11.52-1.16c-4.06,1.45-6.64,5.26-6.49,9.6 c0.14,4.24,3.09,8.03,7.13,9.17c3.88,1.09,7.34,0.64,10.83-1.47c1.09,2.15,2.18,4.28,3.31,6.49c-1.91,1.53-4.1,2.31-6.37,2.72 c-2.88,0.52-5.78,0.85-8.73,0.08c-7.04-1.84-12.1-5.95-14.05-13.04c-1.92-7.01,0.4-12.99,5.92-17.55 c6.46-5.34,13.73-5.55,21.27-2.57C326.47,51.84,327.04,52.34,327.78,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M391.15,65.02c1.8-0.8,3.32-1.74,4.98-2.18c3.2-0.84,7.83,0.92,9.4,3.48c0.59,0.96,1.1,2.15,1.12,3.25 c0.12,4.88,0.05,9.77,0.05,14.77c-2.38,0-4.72,0-7.21,0c0-1.88,0-3.73,0-5.57c0-1.9,0.02-3.81-0.01-5.71 c-0.04-2.88-1.56-4.71-3.87-4.73c-2.4-0.03-4.42,2.19-4.43,4.92c-0.02,3.42-0.01,6.83-0.02,10.25c0,0.25-0.04,0.51-0.06,0.87 c-2.34,0-4.65,0-7.08,0c0-11.75,0-23.53,0-35.4c2.31,0,4.62,0,7.12,0C391.15,54.32,391.15,59.69,391.15,65.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.81,84.44c-0.03-0.62-0.06-1.17-0.1-2.01c-2.38,2.26-5.14,3.12-8.18,2.77c-3.03-0.34-5.5-1.81-7.29-4.31 c-3.23-4.53-2.76-11.25,1.06-15.3c3.11-3.3,9.24-4.37,14.24-0.8c0.11-0.55,0.21-1.02,0.32-1.56c2.34,0,4.69,0,7.15,0 c0,7.05,0,14.08,0,21.21C250.63,84.44,248.25,84.44,245.81,84.44z M240.94,78.75c2.91,0.01,4.86-1.93,4.86-4.82 c0-2.81-2.06-4.97-4.8-4.94c-3.02,0.03-4.77,2.33-4.86,4.76C236.02,76.73,238.43,78.94,240.94,78.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.49,84.41c-2.39,0-4.67,0-7.06,0c-0.06-0.66-0.11-1.27-0.18-2.14c-3.05,2.73-6.41,3.58-10.16,2.43 c-1.99-0.61-3.64-1.78-4.92-3.42c-3.3-4.22-3.26-10.8,0.06-14.78c3.74-4.49,8.22-4.96,15.02-1.53c0.06-0.52,0.11-1.01,0.18-1.59 c2.32,0,4.64,0,7.07,0C355.49,70.36,355.49,77.33,355.49,84.41z M338.49,73.85c-0.01,2.99,2.03,5.02,5.05,5.03 c2.74,0.01,4.93-2.18,4.93-4.93c0-2.85-2.23-5.08-5.07-5.06C340.67,68.9,338.5,71.1,338.49,73.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.41,63.19c1.55,0,2.92,0,4.37,0c0,1.89,0,3.69,0,5.63c-1.37,0-2.77,0-4.3,0c0,2.84-0.09,5.55,0.04,8.24 c0.06,1.24,1.03,1.63,2.25,1.18c0.28-0.1,0.56-0.19,1.01-0.34c0.64,1.96,1.26,3.89,1.88,5.8c-2.84,2.15-9.03,2.21-11.16-0.89 c-0.99-1.45-1.56-3.04-1.58-4.8c-0.03-2.98-0.01-5.95-0.01-9.05c-1.04,0-1.97,0-3.01,0c0-1.95,0-3.78,0-5.76c0.92,0,1.89,0,2.99,0 c0-2.71,0-5.28,0-8.02c2.32,0,4.51-0.04,6.7,0.05c0.28,0.01,0.73,0.67,0.75,1.06c0.09,1.68,0.05,3.37,0.06,5.06 C290.41,61.9,290.41,62.46,290.41,63.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.3,77.67c1.81,0.69,3.47,1.35,5.14,1.94c0.34,0.12,0.83,0.14,1.14-0.02c0.51-0.26,1.23-0.65,1.32-1.09 c0.09-0.46-0.31-1.3-0.74-1.54c-1.15-0.65-2.46-1.01-3.64-1.61c-1.78-0.9-3.55-1.91-4.16-3.99c-1.17-3.99,0.91-7.3,5.34-8.29 c3.35-0.75,6.69-0.53,9.87,0.9c0.27,0.12,0.59,0.74,0.5,0.96c-0.61,1.37-1.33,2.69-1.91,3.83c-1.87-0.34-3.58-0.75-5.31-0.91 c-0.56-0.05-1.49,0.44-1.71,0.93c-0.41,0.9,0.44,1.36,1.19,1.65c1.64,0.64,3.38,1.09,4.91,1.92c4.03,2.18,4.83,7.52,1.61,10.46 c-0.83,0.76-1.94,1.33-3.02,1.66c-4.18,1.28-8.23,0.98-12.09-1.23c-0.96-0.55-1.29-1.06-0.58-2.08 C362.01,79.96,362.7,78.67,363.3,77.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.93,84.49c-2.51,0-4.83,0-7.26,0c0-7.09,0-14.12,0-21.23c2.31,0,4.66,0,7.1,0c0.07,0.8,0.14,1.6,0.22,2.54 c0.83-0.67,1.57-1.28,2.32-1.88c2.24-1.78,5.89-1.59,8.29-0.39c0.22,0.11,0.48,0.58,0.4,0.74c-0.93,2-1.92,3.98-2.75,5.68 c-1.48-0.31-2.71-0.72-3.95-0.78c-2.32-0.11-4,1.27-4.19,3.63c-0.23,2.88-0.15,5.79-0.2,8.68 C266.91,82.44,266.93,83.39,266.93,84.49z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "271.4,93.19 231.81,93.19 244.89,107.13 231.81,121.06 271.4,121.06 284.23,107.13 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "217.8,93.19 178.2,93.19 191.29,107.13 178.2,121.06 217.8,121.06 230.62,107.13 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "165.38,93.19 125.78,93.19 138.86,107.13 125.78,121.06 165.38,121.06 178.2,107.13 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "391.15,93.19 284.23,93.19 297.8,107.13 284.23,121.06 391.15,121.06 403.98,107.13 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 76.34,
    cy: 75.17,
    r: 73.64
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 76.34,
    cy: 75.17,
    r: 60.05
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M321.56,116.46c0-6.58,0-12.75,0-18.91c2.75,0,5.43-0.35,7.99,0.08c3.68,0.62,4.82,5.16,2.19,7.85 c-0.2,0.2-0.43,0.37-0.82,0.71c2.53,0.75,3.91,2.21,3.87,4.81c-0.04,2.51-1.38,4.54-3.9,4.88 C327.87,116.29,324.8,116.28,321.56,116.46z M325.77,112.93c1.65,0.16,3.29,0.37,4.23-1.19c0.33-0.55,0.24-1.76-0.16-2.25 c-1.02-1.25-2.53-1.29-4.06-0.96C325.77,110.05,325.77,111.45,325.77,112.93z M325.74,100.75c0,1.36,0,2.59,0,3.81 c2.12,0.24,3.16-0.38,3.21-1.85C329.01,101.18,328.22,100.67,325.74,100.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M382.6,98.86c-0.55,1.09-1.11,2.2-1.67,3.3c-3.95-1.59-7.18-1.08-8.96,1.34c-1.45,1.98-1.38,4.56,0,6.55 c1.38,1.99,4.93,3.33,8.94,1.35c0.56,1.1,1.12,2.21,1.67,3.29c-3.55,2.86-9.58,2.63-13.39-1.11c-3.88-3.8-3.94-9.35-0.26-13.24 C372.45,96.6,379.07,95.85,382.6,98.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M343.37,114.1c0.69-1.15,1.33-2.22,2.01-3.35c1.14,0.56,2.16,1.19,3.28,1.55c0.82,0.27,1.79,0.37,2.62,0.19 c0.58-0.13,1.38-0.82,1.43-1.32c0.06-0.61-0.43-1.43-0.92-1.9c-0.59-0.56-1.44-0.86-2.19-1.22c-3.9-1.88-5.31-4.26-4.28-7.24 c0.96-2.77,4.43-4.38,8-3.59c1.2,0.27,2.34,0.82,3.71,1.32c-0.62,1.3-1.13,2.35-1.63,3.4c-1.25-0.4-2.37-1.01-3.5-1.03 c-0.86-0.02-2.22-0.05-2.61,1.11c-0.27,0.83,0.77,1.71,1.42,2.16c1.62,1.11,3.56,1.78,5.08,2.99c2.88,2.32,2.16,6.86-1.19,8.53 C351.3,117.33,347.05,116.77,343.37,114.1z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M319.07,116.46c0-6.58,0-12.75,0-18.91c2.75,0,5.43-0.35,7.99,0.08c3.68,0.62,4.82,5.16,2.19,7.85 c-0.2,0.2-0.43,0.37-0.82,0.71c2.53,0.75,3.91,2.21,3.87,4.81c-0.04,2.51-1.38,4.54-3.9,4.88 C325.38,116.29,322.31,116.28,319.07,116.46z M323.29,112.93c1.65,0.16,3.29,0.37,4.23-1.19c0.33-0.55,0.24-1.76-0.16-2.25 c-1.02-1.25-2.53-1.29-4.06-0.96C323.29,110.05,323.29,111.45,323.29,112.93z M323.26,100.75c0,1.36,0,2.59,0,3.81 c2.12,0.24,3.16-0.38,3.21-1.85C326.52,101.18,325.74,100.67,323.26,100.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M380.11,98.86c-0.55,1.09-1.11,2.2-1.67,3.3c-3.95-1.59-7.18-1.08-8.96,1.34c-1.45,1.98-1.38,4.56,0,6.55 c1.38,1.99,4.93,3.33,8.94,1.35c0.56,1.1,1.12,2.21,1.67,3.29c-3.55,2.86-9.58,2.63-13.39-1.11c-3.88-3.8-3.94-9.35-0.26-13.24 C369.97,96.6,376.59,95.85,380.11,98.86z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M340.89,114.1c0.69-1.15,1.33-2.22,2.01-3.35c1.14,0.56,2.16,1.19,3.28,1.55c0.82,0.27,1.79,0.37,2.62,0.19 c0.58-0.13,1.38-0.82,1.43-1.32c0.06-0.61-0.43-1.43-0.92-1.9c-0.59-0.56-1.44-0.86-2.19-1.22c-3.9-1.88-5.31-4.26-4.28-7.24 c0.96-2.77,4.43-4.38,8-3.59c1.2,0.27,2.34,0.82,3.71,1.32c-0.62,1.3-1.13,2.35-1.63,3.4c-1.25-0.4-2.37-1.01-3.5-1.03 c-0.86-0.02-2.22-0.05-2.61,1.11c-0.27,0.83,0.77,1.71,1.42,2.16c1.62,1.11,3.56,1.78,5.08,2.99c2.88,2.32,2.16,6.86-1.19,8.53 C348.82,117.33,344.56,116.77,340.89,114.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M92.52,75.13c10.14-5.58,10.85-13.76,10.85-13.76c2.57-21.59-20.98-21.85-20.98-21.85H49.05v71.31h32.56 c9.88,0,19.47-3.13,21.76-16C105.66,81.95,92.52,75.13,92.52,75.13z M80.66,97.44H66.34V82h14.43c0,0,5.31,0.62,6.21,6.21 C87.87,93.81,82.95,97.39,80.66,97.44z M80.66,68.47H66.34V53.03h14.43c0,0,5.31,0.62,6.21,6.21 C87.87,64.84,82.95,68.42,80.66,68.47z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072261563980804080450000002697654070038443144_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072261563980804080450000002697654070038443144_)",
      fill: "#FFFFFF"
    },
    d: "M92.52,75.13 c10.14-5.58,10.85-13.76,10.85-13.76c2.57-21.59-20.98-21.85-20.98-21.85H49.05v71.31h32.56c9.88,0,19.47-3.13,21.76-16 C105.66,81.95,92.52,75.13,92.52,75.13z M80.66,97.44H66.34V82h14.43c0,0,5.31,0.62,6.21,6.21C87.87,93.81,82.95,97.39,80.66,97.44 z M80.66,68.47H66.34V53.03h14.43c0,0,5.31,0.62,6.21,6.21C87.87,64.84,82.95,68.42,80.66,68.47z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072261563980804080450000002697654070038443144_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000091708025020961574570000002116403439016210869_",
    points: "76.54,55.61 55.86,34.89 54.29,36.45  74.96,57.17  "
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098928698744731482820000016063411517784308105_",
    points: "71.8,58.52 51.12,37.8 49.55,39.36  70.22,60.08  "
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000081628658044568275840000016256689999038815931_",
    d: "M67.61,43.11c0.22,0,0.43-0.03,0.63-0.09L82.5,57.17 l1.57-1.56L69.7,41.34c0.02-0.11,0.03-0.23,0.03-0.34c0-1.17-0.95-2.12-2.12-2.12c-1.17,0-2.12,0.95-2.12,2.12 S66.44,43.11,67.61,43.11z"
  }))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000071559379076961087340000001090325665172184478_",
    d: "M58.04,57.81c0,1.17,0.95,2.12,2.12,2.12 c1.17,0,2.12-0.95,2.12-2.12c0-1.17-0.95-2.12-2.12-2.12c-0.1,0-0.2,0.01-0.29,0.02L44.78,41.32l-1.53,1.61l14.9,14.22 C58.08,57.36,58.04,57.58,58.04,57.81z"
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183208329009324910410000012762271385377244840_",
    points: "70.22,90.27 49.55,110.99 51.12,112.55  71.8,91.83  "
  }))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000143595218444847152740000008796851855907791549_",
    points: "74.96,93.18 54.29,113.9 55.86,115.46  76.54,94.74  "
  }))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000080179095248385961820000000858353079082544532_",
    d: "M82.5,93.18l-14.26,14.15 c-0.2-0.06-0.41-0.09-0.63-0.09c-1.17,0-2.12,0.95-2.12,2.12c0,1.17,0.95,2.12,2.12,2.12c1.17,0,2.12-0.95,2.12-2.12 c0-0.12-0.01-0.23-0.03-0.34l14.38-14.27L82.5,93.18z"
  }))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000103947814790427104020000008957506725953823667_",
    d: "M60.16,94.65c1.17,0,2.12-0.95,2.12-2.12 c0-1.17-0.95-2.12-2.12-2.12c-1.17,0-2.12,0.95-2.12,2.12c0,0.23,0.04,0.45,0.11,0.66l-14.9,14.22l1.53,1.61l15.08-14.39 C59.96,94.64,60.06,94.65,60.16,94.65z"
  }))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000070799060253811009320000015449579349425093773_",
    points: "58.04,70.65 37.37,49.94 35.79,51.5  55.82,71.57 55.8,78.79 35.76,98.86 37.34,100.42 58.01,79.71  "
  }))), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000028308278137414138600000009675839230523125690_",
    points: "63.32,68.51 42.65,47.8 41.07,49.36  61.1,69.43 61.08,80.98 41.04,101.05 42.62,102.62 63.29,81.9  "
  }))), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000112613833391311096110000000116486765633891770_",
    x: 41.89,
    y: 70.58,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -39.5384 54.8807)",
    width: 9.17,
    height: 9.17
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026133401268329365090000014428640748500602294_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091708025020961574570000002116403439016210869_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014633067606080956570000015362265858409519537_",
    style: {
      clipPath: "url(#SVGID_00000026133401268329365090000014428640748500602294_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098928698744731482820000016063411517784308105_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059281258587154263200000006596741492617001656_",
    style: {
      clipPath: "url(#SVGID_00000014633067606080956570000015362265858409519537_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081628658044568275840000016256689999038815931_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011752049343094853130000016626209689190769080_",
    style: {
      clipPath: "url(#SVGID_00000059281258587154263200000006596741492617001656_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071559379076961087340000001090325665172184478_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044152903947945143540000013268895015029986981_",
    style: {
      clipPath: "url(#SVGID_00000011752049343094853130000016626209689190769080_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183208329009324910410000012762271385377244840_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146470589593556970960000004752141417200896703_",
    style: {
      clipPath: "url(#SVGID_00000044152903947945143540000013268895015029986981_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143595218444847152740000008796851855907791549_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137833103203630702780000005499459711823654814_",
    style: {
      clipPath: "url(#SVGID_00000146470589593556970960000004752141417200896703_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080179095248385961820000000858353079082544532_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073708958235991755190000000115328607284818060_",
    style: {
      clipPath: "url(#SVGID_00000137833103203630702780000005499459711823654814_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103947814790427104020000008957506725953823667_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126298327730625917150000015784763771805191853_",
    style: {
      clipPath: "url(#SVGID_00000073708958235991755190000000115328607284818060_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070799060253811009320000015449579349425093773_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116201661513148706670000003365617407754140831_",
    style: {
      clipPath: "url(#SVGID_00000126298327730625917150000015784763771805191853_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028308278137414138600000009675839230523125690_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083061737365805132310000015688306806259529390_",
    style: {
      clipPath: "url(#SVGID_00000116201661513148706670000003365617407754140831_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112613833391311096110000000116486765633891770_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000089552560642006663910000004214594074794248602_",
    points: "76.54,55.61 55.86,34.89 54.29,36.45  74.96,57.17  "
  }))), _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008856732570569445570000014140104626180772521_",
    points: "71.8,58.52 51.12,37.8 49.55,39.36  70.22,60.08  "
  }))), _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000137098613285767744760000006343723821333384088_",
    d: "M67.61,43.11c0.22,0,0.43-0.03,0.63-0.09L82.5,57.17 l1.57-1.56L69.7,41.34c0.02-0.11,0.03-0.23,0.03-0.34c0-1.17-0.95-2.12-2.12-2.12c-1.17,0-2.12,0.95-2.12,2.12 S66.44,43.11,67.61,43.11z"
  }))), _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000030450074792584844200000005587777244451469494_",
    d: "M58.04,57.81c0,1.17,0.95,2.12,2.12,2.12 c1.17,0,2.12-0.95,2.12-2.12c0-1.17-0.95-2.12-2.12-2.12c-0.1,0-0.2,0.01-0.29,0.02L44.78,41.32l-1.53,1.61l14.9,14.22 C58.08,57.36,58.04,57.58,58.04,57.81z"
  }))), _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000036967929151157136010000005609547684553052843_",
    points: "70.22,90.27 49.55,110.99 51.12,112.55  71.8,91.83  "
  }))), _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000175285375142161214110000006513375162176379791_",
    points: "74.96,93.18 54.29,113.9 55.86,115.46  76.54,94.74  "
  }))), _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000142151172645126730160000007467698736962752179_",
    d: "M82.5,93.18l-14.26,14.15 c-0.2-0.06-0.41-0.09-0.63-0.09c-1.17,0-2.12,0.95-2.12,2.12c0,1.17,0.95,2.12,2.12,2.12c1.17,0,2.12-0.95,2.12-2.12 c0-0.12-0.01-0.23-0.03-0.34l14.38-14.27L82.5,93.18z"
  }))), _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000083071110542569878640000011060206915885816459_",
    d: "M60.16,94.65c1.17,0,2.12-0.95,2.12-2.12 c0-1.17-0.95-2.12-2.12-2.12c-1.17,0-2.12,0.95-2.12,2.12c0,0.23,0.04,0.45,0.11,0.66l-14.9,14.22l1.53,1.61l15.08-14.39 C59.96,94.64,60.06,94.65,60.16,94.65z"
  }))), _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000000196073487979114880000006080571511823781254_",
    points: "58.04,70.65 37.37,49.94 35.79,51.5  55.82,71.57 55.8,78.79 35.76,98.86 37.34,100.42 58.01,79.71  "
  }))), _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000080917788059738389000000017080286569981382282_",
    points: "63.32,68.51 42.65,47.8 41.07,49.36  61.1,69.43 61.08,80.98 41.04,101.05 42.62,102.62 63.29,81.9  "
  }))), _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000171715237722331240640000015381682099845679272_",
    x: 41.89,
    y: 70.58,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -39.5384 54.8807)",
    width: 9.17,
    height: 9.17
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089552560642006663910000004214594074794248602_",
    style: {
      overflow: "visible",
      fill: "#00C160"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008856732570569445570000014140104626180772521_",
    style: {
      overflow: "visible",
      fill: "#00C160"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137098613285767744760000006343723821333384088_",
    style: {
      overflow: "visible",
      fill: "#00C160"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030450074792584844200000005587777244451469494_",
    style: {
      overflow: "visible",
      fill: "#00C160"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036967929151157136010000005609547684553052843_",
    style: {
      overflow: "visible",
      fill: "#00C160"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175285375142161214110000006513375162176379791_",
    style: {
      overflow: "visible",
      fill: "#00C160"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142151172645126730160000007467698736962752179_",
    style: {
      overflow: "visible",
      fill: "#00C160"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083071110542569878640000011060206915885816459_",
    style: {
      overflow: "visible",
      fill: "#00C160"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000196073487979114880000006080571511823781254_",
    style: {
      overflow: "visible",
      fill: "#00C160"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080917788059738389000000017080286569981382282_",
    style: {
      overflow: "visible",
      fill: "#00C160"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171715237722331240640000015381682099845679272_",
    style: {
      overflow: "visible",
      fill: "#00C160"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099627442250262182400000011265993557685814928_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089552560642006663910000004214594074794248602_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176735882695169887880000010762956593847064203_",
    style: {
      clipPath: "url(#SVGID_00000099627442250262182400000011265993557685814928_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008856732570569445570000014140104626180772521_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110472592674230821240000017429639967017178240_",
    style: {
      clipPath: "url(#SVGID_00000176735882695169887880000010762956593847064203_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137098613285767744760000006343723821333384088_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033327995590393340090000006733376327629250233_",
    style: {
      clipPath: "url(#SVGID_00000110472592674230821240000017429639967017178240_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030450074792584844200000005587777244451469494_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085930212692964905540000003509104555806644661_",
    style: {
      clipPath: "url(#SVGID_00000033327995590393340090000006733376327629250233_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036967929151157136010000005609547684553052843_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038392365529157959370000011137677202626231213_",
    style: {
      clipPath: "url(#SVGID_00000085930212692964905540000003509104555806644661_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175285375142161214110000006513375162176379791_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114045577905129926440000000605532106752688771_",
    style: {
      clipPath: "url(#SVGID_00000038392365529157959370000011137677202626231213_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142151172645126730160000007467698736962752179_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150078786367291960520000012005035820089702832_",
    style: {
      clipPath: "url(#SVGID_00000114045577905129926440000000605532106752688771_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083071110542569878640000011060206915885816459_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044883177370820831440000017288955955832211644_",
    style: {
      clipPath: "url(#SVGID_00000150078786367291960520000012005035820089702832_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000196073487979114880000006080571511823781254_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035502777343939834490000000635568078225508747_",
    style: {
      clipPath: "url(#SVGID_00000044883177370820831440000017288955955832211644_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080917788059738389000000017080286569981382282_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026880454787036572520000011442481044647810451_",
    style: {
      clipPath: "url(#SVGID_00000035502777343939834490000000635568078225508747_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171715237722331240640000015381682099845679272_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000026880454787036572520000011442481044647810451_)",
      fill: "#00C160"
    },
    d: "M92.52,75.13 c10.14-5.58,10.85-13.76,10.85-13.76c2.57-21.59-20.98-21.85-20.98-21.85H49.05v71.31h32.56c9.88,0,19.47-3.13,21.76-16 C105.66,81.95,92.52,75.13,92.52,75.13z M80.66,97.44H66.34V82h14.43c0,0,5.31,0.62,6.21,6.21 C87.87,93.81,82.95,97.39,80.66,97.44z M80.66,68.47H66.34V53.03h14.43c0,0,5.31,0.62,6.21,6.21 C87.87,64.84,82.95,68.42,80.66,68.47z"
  })), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000108309241719654393730000003310497168137702836_",
    points: "76.54,55.61 55.86,34.89 54.29,36.45  74.96,57.17  "
  }))), _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096032111865989153140000002825772221653222842_",
    points: "71.8,58.52 51.12,37.8 49.55,39.36  70.22,60.08  "
  }))), _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000132067589044101833790000015096921530443777440_",
    d: "M67.61,43.11c0.22,0,0.43-0.03,0.63-0.09L82.5,57.17 l1.57-1.56L69.7,41.34c0.02-0.11,0.03-0.23,0.03-0.34c0-1.17-0.95-2.12-2.12-2.12c-1.17,0-2.12,0.95-2.12,2.12 S66.44,43.11,67.61,43.11z"
  }))), _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000146470540524394735450000002975911604492751783_",
    d: "M58.04,57.81c0,1.17,0.95,2.12,2.12,2.12 c1.17,0,2.12-0.95,2.12-2.12c0-1.17-0.95-2.12-2.12-2.12c-0.1,0-0.2,0.01-0.29,0.02L44.78,41.32l-1.53,1.61l14.9,14.22 C58.08,57.36,58.04,57.58,58.04,57.81z"
  }))), _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000025405815186703677960000014096999936299130276_",
    points: "70.22,90.27 49.55,110.99 51.12,112.55  71.8,91.83  "
  }))), _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000172403586886542293420000003365296052074353029_",
    points: "74.96,93.18 54.29,113.9 55.86,115.46  76.54,94.74  "
  }))), _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000155867943213935296500000014323523903585908365_",
    d: "M82.5,93.18l-14.26,14.15 c-0.2-0.06-0.41-0.09-0.63-0.09c-1.17,0-2.12,0.95-2.12,2.12c0,1.17,0.95,2.12,2.12,2.12c1.17,0,2.12-0.95,2.12-2.12 c0-0.12-0.01-0.23-0.03-0.34l14.38-14.27L82.5,93.18z"
  }))), _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000086685617336611484620000009391466549506025635_",
    d: "M60.16,94.65c1.17,0,2.12-0.95,2.12-2.12 c0-1.17-0.95-2.12-2.12-2.12c-1.17,0-2.12,0.95-2.12,2.12c0,0.23,0.04,0.45,0.11,0.66l-14.9,14.22l1.53,1.61l15.08-14.39 C59.96,94.64,60.06,94.65,60.16,94.65z"
  }))), _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000080928201684969244570000007737548182753703605_",
    points: "58.04,70.65 37.37,49.94 35.79,51.5  55.82,71.57 55.8,78.79 35.76,98.86 37.34,100.42 58.01,79.71  "
  }))), _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121963531875908038010000007385860262860687537_",
    points: "63.32,68.51 42.65,47.8 41.07,49.36  61.1,69.43 61.08,80.98 41.04,101.05 42.62,102.62 63.29,81.9  "
  }))), _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000020358144422393585340000004048483572646361770_",
    x: 41.89,
    y: 70.58,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -39.5384 54.8807)",
    width: 9.17,
    height: 9.17
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067942587254287343100000014519896082122808485_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108309241719654393730000003310497168137702836_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142139684520007450800000018281127140914339515_",
    style: {
      clipPath: "url(#SVGID_00000067942587254287343100000014519896082122808485_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096032111865989153140000002825772221653222842_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053545807628383034160000002429328782193530030_",
    style: {
      clipPath: "url(#SVGID_00000142139684520007450800000018281127140914339515_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132067589044101833790000015096921530443777440_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168114598230321915660000014893416098416173710_",
    style: {
      clipPath: "url(#SVGID_00000053545807628383034160000002429328782193530030_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146470540524394735450000002975911604492751783_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179642645537966985850000015697197876735550122_",
    style: {
      clipPath: "url(#SVGID_00000168114598230321915660000014893416098416173710_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025405815186703677960000014096999936299130276_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168078806413065749430000010201695021696374199_",
    style: {
      clipPath: "url(#SVGID_00000179642645537966985850000015697197876735550122_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172403586886542293420000003365296052074353029_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121981441336777983380000005486987981742668705_",
    style: {
      clipPath: "url(#SVGID_00000168078806413065749430000010201695021696374199_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155867943213935296500000014323523903585908365_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117643005683022868520000006695232889231326870_",
    style: {
      clipPath: "url(#SVGID_00000121981441336777983380000005486987981742668705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086685617336611484620000009391466549506025635_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173879595376747254400000013618547735335556277_",
    style: {
      clipPath: "url(#SVGID_00000117643005683022868520000006695232889231326870_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080928201684969244570000007737548182753703605_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093858849791484958480000014386191285294786488_",
    style: {
      clipPath: "url(#SVGID_00000173879595376747254400000013618547735335556277_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121963531875908038010000007385860262860687537_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083776256947331422110000012491203138840854698_",
    style: {
      clipPath: "url(#SVGID_00000093858849791484958480000014386191285294786488_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020358144422393585340000004048483572646361770_",
    style: {
      overflow: "visible"
    }
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M191.24,83.78c-2.5,0-4.82,0-7.23,0c0-7.09,0-14.12,0-21.22c2.34,0,4.69,0,7.1,0 c0.07,0.63,0.13,1.25,0.2,1.89c5.93-3.64,10.22-3.31,13.31,0.77c1.78-1.03,3.41-2.44,5.29-2.97c4.66-1.32,10.6,1.19,10.37,7.47 c-0.16,4.19-0.03,8.39-0.03,12.59c0,0.46,0,0.93,0,1.46c-2.54,0-4.94,0-7.51,0c0-1.19,0-2.3,0-3.41c-0.01-3.03,0.01-6.06-0.03-9.09 c-0.02-1.76-1.1-2.96-2.85-3.31c-1.61-0.32-3.18,0.42-3.69,1.87c-0.24,0.67-0.26,1.43-0.27,2.16c-0.03,3.5-0.05,7.01,0.01,10.51 c0.02,1.11-0.37,1.41-1.41,1.38c-2.03-0.06-4.06-0.02-6.31-0.02c0-0.67,0-1.17,0-1.66c0-3.63,0.01-7.27-0.02-10.9 c-0.01-1.88-1.31-3.23-3.18-3.38c-1.96-0.15-3.42,0.87-3.54,2.87c-0.21,3.53-0.17,7.08-0.22,10.62 C191.23,82.16,191.24,82.89,191.24,83.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M152.94,79.89c1.29-2.17,2.57-4.33,3.77-6.34c2.08,1.05,4.03,2.19,6.11,3.05c1.82,0.75,3.78,0.82,5.62-0.07 c2.15-1.05,2.45-3.37,0.49-4.71c-1.78-1.21-3.76-2.16-5.7-3.12c-3.36-1.67-6.24-3.73-7.12-7.7c-0.66-2.99,0.14-5.64,2.03-7.89 c3.38-4.02,7.84-4.82,12.74-3.81c2.45,0.51,4.87,1.23,7.02,2.88c-0.94,1.87-1.88,3.76-2.82,5.65c-0.32,0.64-0.68,0.53-1.24,0.23 c-2.14-1.14-4.38-2.08-6.86-1.76c-0.88,0.11-1.83,0.53-2.51,1.09c-1.11,0.92-1.11,2.41,0.08,3.22c1.65,1.13,3.43,2.09,5.26,2.91 c2.93,1.32,5.63,2.9,7.65,5.48c2.69,3.44,1.84,11.71-4.58,14.24c-3.18,1.25-6.43,1.54-9.83,1.11c-3.54-0.45-6.6-1.89-9.5-3.82 C153.33,80.38,153.18,80.15,152.94,79.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M324.29,52.11c-1.14,2.27-2.19,4.37-3.27,6.53c-3.75-2.11-7.55-2.58-11.52-1.16 c-4.06,1.45-6.64,5.26-6.49,9.6c0.14,4.24,3.09,8.03,7.13,9.17c3.88,1.09,7.34,0.64,10.83-1.47c1.09,2.15,2.18,4.28,3.31,6.49 c-1.91,1.53-4.1,2.31-6.37,2.72c-2.88,0.52-5.78,0.85-8.73,0.08c-7.04-1.84-12.1-5.95-14.05-13.04c-1.92-7.01,0.4-12.99,5.92-17.55 c6.46-5.34,13.73-5.55,21.27-2.57C322.98,51.15,323.55,51.64,324.29,52.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M387.67,64.33c1.8-0.8,3.32-1.74,4.98-2.18c3.2-0.84,7.83,0.92,9.4,3.48c0.59,0.96,1.1,2.15,1.12,3.25 c0.12,4.88,0.05,9.77,0.05,14.77c-2.38,0-4.72,0-7.21,0c0-1.88,0-3.73,0-5.57c0-1.9,0.02-3.81-0.01-5.71 c-0.04-2.88-1.56-4.71-3.87-4.73c-2.4-0.03-4.42,2.19-4.43,4.92c-0.02,3.42-0.01,6.83-0.02,10.25c0,0.25-0.04,0.51-0.06,0.87 c-2.34,0-4.65,0-7.08,0c0-11.75,0-23.53,0-35.4c2.31,0,4.62,0,7.12,0C387.67,53.62,387.67,59,387.67,64.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M242.33,83.75c-0.03-0.62-0.06-1.17-0.1-2.01c-2.38,2.26-5.14,3.12-8.18,2.77c-3.03-0.34-5.5-1.81-7.29-4.31 c-3.23-4.53-2.76-11.25,1.06-15.3c3.11-3.3,9.24-4.37,14.24-0.8c0.11-0.55,0.21-1.02,0.32-1.56c2.34,0,4.69,0,7.15,0 c0,7.05,0,14.08,0,21.21C247.14,83.75,244.76,83.75,242.33,83.75z M237.45,78.06c2.91,0.01,4.86-1.93,4.86-4.82 c0-2.81-2.06-4.97-4.8-4.94c-3.02,0.03-4.77,2.33-4.86,4.76C232.54,76.03,234.95,78.25,237.45,78.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M352,83.72c-2.39,0-4.67,0-7.06,0c-0.06-0.66-0.11-1.27-0.18-2.14c-3.05,2.73-6.41,3.58-10.16,2.43 c-1.99-0.61-3.64-1.78-4.92-3.42c-3.3-4.22-3.26-10.8,0.06-14.78c3.74-4.49,8.22-4.96,15.02-1.53c0.06-0.52,0.11-1.01,0.18-1.59 c2.32,0,4.64,0,7.07,0C352,69.66,352,76.63,352,83.72z M335,73.16c-0.01,2.99,2.03,5.02,5.05,5.03c2.74,0.01,4.93-2.18,4.93-4.93 c0-2.85-2.23-5.08-5.07-5.06C337.19,68.2,335.01,70.41,335,73.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M286.92,62.5c1.55,0,2.92,0,4.37,0c0,1.89,0,3.69,0,5.63c-1.37,0-2.77,0-4.3,0c0,2.84-0.09,5.55,0.04,8.24 c0.06,1.24,1.03,1.63,2.25,1.18c0.28-0.1,0.56-0.19,1.01-0.34c0.64,1.96,1.26,3.89,1.88,5.8c-2.84,2.15-9.03,2.21-11.16-0.89 c-0.99-1.45-1.56-3.04-1.58-4.8c-0.03-2.98-0.01-5.95-0.01-9.05c-1.04,0-1.97,0-3.01,0c0-1.95,0-3.78,0-5.76c0.92,0,1.89,0,2.99,0 c0-2.71,0-5.28,0-8.02c2.32,0,4.51-0.04,6.7,0.05c0.28,0.01,0.73,0.67,0.75,1.06c0.09,1.68,0.05,3.37,0.06,5.06 C286.93,61.21,286.92,61.76,286.92,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M359.81,76.97c1.81,0.69,3.47,1.35,5.14,1.94c0.34,0.12,0.83,0.14,1.14-0.02c0.51-0.26,1.23-0.65,1.32-1.09 c0.09-0.46-0.31-1.3-0.74-1.54c-1.15-0.65-2.46-1.01-3.64-1.61c-1.78-0.9-3.55-1.91-4.16-3.99c-1.17-3.99,0.91-7.3,5.34-8.29 c3.35-0.75,6.69-0.53,9.87,0.9c0.27,0.12,0.59,0.74,0.5,0.96c-0.61,1.37-1.33,2.69-1.91,3.83c-1.87-0.34-3.58-0.75-5.31-0.91 c-0.56-0.05-1.49,0.44-1.71,0.93c-0.41,0.9,0.44,1.36,1.19,1.65c1.64,0.64,3.38,1.09,4.91,1.92c4.03,2.18,4.83,7.52,1.61,10.46 c-0.83,0.76-1.94,1.33-3.02,1.66c-4.18,1.28-8.23,0.98-12.09-1.23c-0.96-0.55-1.29-1.06-0.58-2.08 C358.52,79.26,359.21,77.97,359.81,76.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M263.44,83.8c-2.51,0-4.83,0-7.26,0c0-7.09,0-14.12,0-21.23c2.31,0,4.66,0,7.1,0c0.07,0.8,0.14,1.6,0.22,2.54 c0.83-0.67,1.57-1.28,2.32-1.88c2.24-1.78,5.89-1.59,8.29-0.39c0.22,0.11,0.48,0.58,0.4,0.74c-0.93,2-1.92,3.98-2.75,5.68 c-1.48-0.31-2.71-0.72-3.95-0.78c-2.32-0.11-4,1.27-4.19,3.63c-0.23,2.88-0.15,5.79-0.2,8.68C263.43,81.75,263.44,82.7,263.44,83.8 z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f34d69cd3b1b9320347942c3fadf6750.svg";
export { ForwardRef as ReactComponent };